/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Map drawing functions
namespace('Slzr.Maps', function(exports, top) {
  const $ = Slzr.jQuery;

  return exports.Map = class Map {
    // Initialize the map
    //
    // Options include:
    //   element: (required) the container for the map
    //   zoom: (require) the initial zoom level
    //   overlays: array of URLs to KML/georss overlays
    //   points: array of [lat, lng, url] points to put markers at.  url is optional, and will link there if given
    //   infoWindow: element to show as an info window at the first point
    constructor(options) {
      this.addOverlay = this.addOverlay.bind(this);
      this.showInfoWindow = this.showInfoWindow.bind(this);
      this.addMarker = this.addMarker.bind(this);
      this.options = options;

      this.overlays = [];
      this.points = [];
      this.markers = [];
      this.bounds = new google.maps.LatLngBounds;

      this.marker_image = new google.maps.MarkerImage('https://www.localist.com/assets/main/pin.png', null, null, new google.maps.Point(10, 32), new google.maps.Size(20, 32)); // WP_CHANGE: hostname may not be correct
      this.marker_shadow = new google.maps.MarkerImage('https://www.localist.com/assets/main/pin_shadow.png', null, null, new google.maps.Point(10, 32), new google.maps.Size(36, 32)); // WP_CHANGE: hostname may not be correct
      this.marker_shape = {
        coord: [26, 0, 28, 1, 30, 2, 32, 3, 33, 4, 34, 5, 35, 6, 36, 7, 36, 8, 37, 9, 38, 10, 38, 11, 38, 12, 39, 13, 39, 14, 39, 15, 39, 16, 39, 17, 39, 18, 39, 19, 39, 20, 39, 21, 39, 22, 39, 23, 39, 24, 39, 25, 39, 26, 38, 27, 38, 28, 38, 29, 37, 30, 37, 31, 37, 32, 36, 33, 36, 34, 35, 35, 35, 36, 34, 37, 34, 38, 34, 39, 33, 40, 33, 41, 32, 42, 32, 43, 31, 44, 31, 45, 30, 46, 30, 47, 29, 48, 29, 49, 28, 50, 28, 51, 27, 52, 26, 53, 26, 54, 25, 55, 25, 56, 24, 57, 24, 58, 23, 59, 23, 60, 22, 61, 21, 62, 21, 63, 18, 63, 18, 62, 17, 61, 17, 60, 16, 59, 15, 58, 15, 57, 14, 56, 14, 55, 13, 54, 13, 53, 12, 52, 12, 51, 11, 50, 11, 49, 10, 48, 10, 47, 9, 46, 8, 45, 8, 44, 7, 43, 7, 42, 7, 41, 6, 40, 6, 39, 5, 38, 5, 37, 4, 36, 4, 35, 3, 34, 3, 33, 2, 32, 2, 31, 2, 30, 1, 29, 1, 28, 1, 27, 0, 26, 0, 25, 0, 24, 0, 23, 0, 22, 0, 21, 0, 20, 0, 19, 0, 18, 0, 17, 0, 16, 0, 15, 0, 14, 0, 13, 1, 12, 1, 11, 2, 10, 2, 9, 3, 8, 4, 7, 4, 6, 5, 5, 6, 4, 8, 3, 9, 2, 11, 1, 13, 0, 26, 0],
        type: 'poly'
      };

      this.map = new google.maps.Map(options.element, {
        zoom: options.zoom,
        mapTypeId: options.satellite ? google.maps.MapTypeId.HYBRID : google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        overviewMapControl: false,
        mapTypeControl: false
      }
      );

      for (const url of Array.from(options.overlays)) { this.addOverlay(url); }
      for (const point of Array.from(options.points)) { this.addMarker(point[0], point[1], point[2]); }
      if (options.infoWindow != null) { this.showInfoWindow; }
    }

    // Add a KML/GeoRSS overlay to the map
    addOverlay(url) {
      this.overlays.push(url);

      const overlay = new google.maps.KmlLayer(url, {preserveViewport: true});
      overlay.setMap(this.map);
      return overlay;
    }

    // Show an info window
    showInfoWindow() {
      const infoWindow = new google.maps.InfoWindow({content: this.options.infoWindow});
      $(this.options.infoWindow).show();
      infoWindow.open(map, this.markers[0]);
      return infoWindow;
    }

    // Add a marker at 
    addMarker(lat, lng, url = null) {
      this.points.push([lat, lng]);

      const point = new google.maps.LatLng(lat, lng);
      const marker = new google.maps.Marker({position: point, map: this.map, icon: this.marker_image, shadow: this.marker_shadow, shape: this.marker_shape});
      this.markers.push(marker);

      if (url != null) { google.maps.event.addListener(marker, 'click', () => window.open(url)); }

      this.bounds.extend(point);
      if (this.markers.length > 1) {
        this.map.fitBounds(this.bounds);
      } else {
        this.map.setCenter(point);
        this.map.setZoom(this.options.zoom);
      }

      return marker;
    }
  };
});

// Maps (2) utility functions
namespace('SlzrMaps', function(exports, top) {
  // Draw a circle as a map overlay
  //
  // map: the google map instance
  // center: GLatLng of the center point
  // radius: radius of the circle
  // options: units: 'km' or 'mi' (default=mi)
  //
  // Returns the GPolygon
  exports.drawCircle = function(map, center, radius, options) {
    let d;
    if (!options) { options = {}; }
    options.units = options.units || 'mi';

    const points = [];

    if ((options.units === 'km') || (options.units === 'kms')) {
      d = radius / 6378.8;
    } else {
      d = radius / 3963.189;
    }

    const lat1 = center.lat() * (Math.PI / 180);
    const lng1 = center.lng() * (Math.PI / 180);

    for (let i = 0; i <= 360; i++) {
      const tc = i * (Math.PI / 180);
      const y = Math.asin((Math.sin(lat1) * Math.cos(d)) + (Math.cos(lat1) * Math.sin(d) * Math.cos(tc)));
      const dlng = Math.atan2(Math.sin(tc) * Math.sin(d) * Math.cos(lat1), Math.cos(d) - (Math.sin(lat1) * Math.sin(y)));
      const x = (((lng1 - dlng) + Math.PI) % (2 * Math.PI)) - Math.PI;
      const point = new GLatLng(parseFloat(y * (180 / Math.PI)), parseFloat(x * (180 / Math.PI)));
      points.push(point);
    }

    const poly = new GPolygon(points);
    map.addOverlay(poly);
    return poly;
  };

  // Make the specified map instance static
  //
  // That is, disable any interaction
  return exports.makeStatic = function(map) {
    map.disableDragging();
    map.disableInfoWindow();
    map.disableDoubleClickZoom();
    map.disableScrollWheelZoom();
    map.disablePinchToZoom();
    return map.disableGoogleBar();
  };
});
